import React from 'react';

const PatientPharmacy = () => {
  const pharmacyOrders = [
    {
      medicine: 'Paracetamol 500mg',
      date: '2025-06-15',
      quantity: 2,
      price: '₹40',
      prescribedBy: 'Dr. John Smith',
      status: 'Delivered',
    },
    {
      medicine: 'Amoxicillin 250mg',
      date: '2025-06-10',
      quantity: 1,
      price: '₹60',
      prescribedBy: 'Dr. Sarah Lee',
      status: 'Delivered',
    },
    {
      medicine: 'Vitamin D3',
      date: '2025-06-08',
      quantity: 1,
      price: '₹150',
      prescribedBy: 'Dr. Rahul Mehta',
      status: 'Pending',
    },
    {
      medicine: 'Ibuprofen 400mg',
      date: '2025-06-01',
      quantity: 1,
      price: '₹30',
      prescribedBy: 'Dr. Priya Nair',
      status: 'Delivered',
    },
  ];

  return (
    <div style={{ padding: '20px' }}>
      <h3>Pharmacy Orders</h3>

      <table className="full-width-table">
        <thead>
          <tr>
            <th>Medicine</th>
            <th>Purchase Date</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Prescribed By</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {pharmacyOrders.map((order, index) => (
            <tr key={index}>
              <td>{order.medicine}</td>
              <td>{order.date}</td>
              <td>{order.quantity}</td>
              <td>{order.price}</td>
              <td>{order.prescribedBy}</td>
              <td>{order.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PatientPharmacy;
